module.exports = __webpack_public_path__ + "media/images/404-c04a49b5bdc4b22ae1d74d0dd351ed76.png";